import Drip from 'drip';
export function mtguardInit() {
  window.H5guard && window.H5guard.init({
    xhrHook: true,
    //xhrHook开关，开启后默认对domains里面的xhr请求加签
    fetchHook: true,
    //fetchHook开关，开启后默认对domains里面的xhr请求加签
    domains: ['m.51ping.com', 'm.dianping.com', 'show.test.maoyan.com', 'show.maoyan.com', 'wx.maoyan.com', 'yanchu.maoyan.com'],
    //域名白名单配合xhrHook和fetchHook使用，开启之后只会对白名单内的域名请求自动加签，避免出现非业务域名跨域问题
    openId: Drip.User.openId || '',
    //如果当前为wx小程序环境中的h5，传入openId，有助于描述设备画像
    geo: false //如果当前页面有位置权限，则打开开关，H5guard会去收集地理位置信息，如果为false,地理位置默认为“”空字符串

  });

  if (!window.H5guard) {
    window.Owl && window.Owl.addError({
      name: "H5guard\u4E0D\u5B58\u5728 sellChannel=".concat(Drip.constant.sellChannel),
      msg: {
        uaInfo: Drip.constant.uaInfo
      }
    }, {
      category: 'jsError',
      level: 'error'
    });
  }
}